export default {
  geolocation: {
    lat: '50.846667',
    lng: '4.3525',
    label: '1000 Bruxelles',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
